export default __webpack_public_path__ + "static/media/DC4.5fd3e050.png";